module.exports = __webpack_public_path__ + "static/media/googleplay.886f501b.png";